import React, { useEffect } from "react";
import "./metodologia.css";
import data from "../../json/cimetodologiaitems";

const Metodologia = () => {

  // =================================================
  // 🔹 SCROLL AL INICIO
  // =================================================
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
  className="container-full-width cinterno-bg"
  style={{
    backgroundImage: `url(${data.background})`,
    backgroundSize: "30%",        // Hace que la imagen cubra 30% del contenedor
    backgroundPosition: "center",   // Centra la imagen
    backgroundRepeat: "repeat",  // imagen en mosaico
    width: "100%",
    minHeight: "100vh"              // Ocupa toda la altura de la pantalla
  }}
>

      {/* ================================================= */}
      {/* 1️⃣ ENCABEZADO */}
      {/* ================================================= */}
       <h3
            className='title'
            style={{
              color: 'var(--wine)',
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Metodología
          </h3>
          <hr className='hr-gob' />

      {/* ================================================= */}
      {/* 2️⃣ ENLACES */}
      {/* ================================================= */}
      <div className="subheader-links">
        {data.links?.map((link, index) => (
          <a key={index} href={link.url} className="link-custom">
            {link.texto}
          </a>
        ))}
      </div>

      {/* ================================================= */}
      {/* 3️⃣ CONTENIDO */}
      {/* ================================================= */}
      <div className="pdf-section">

        {data.pdfs?.map((item) => (
          <div className="pdf-block" key={item.id}>

            {/* 🔴 CUADRO DE TEXTO */}
            <div className="cuadro-text">
              <h4>{item.tituloTexto}</h4>

              <p
                dangerouslySetInnerHTML={{
                  __html: item.descripcion
                }}
              />
             

            {/* ⚪ PDF (MISMO ANCHO) */}
            <div className="pdf-viewer-container">

              <h4 className="pdf-viewer-title">
                {item.tituloPdf}
              </h4>

              <iframe
                src={item.url}
                title={item.tituloPdf}
              />

            </div>
          </div>

          </div>
        ))}

      </div>

    </div>
  );
};

export default Metodologia;